import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';

import { UserControlIcon, AuditIcon } from 'components/Icons';
import OneRowData from 'components/OneRowData';
import { permissionService } from 'shared/services';

import route from 'route';

import './SideBar.style.less';

// IMPORT MODULE
import Organization from 'modules/Organization/components/OrganizationMenu';
// temporary disabled
import AllBillers from 'modules/AllBillers/components/AllBillersMenu';
import GoldMenu from 'modules/Gold/components/GoldMenu/GoldMenu.component';
import Delivery from 'modules/Delivery/components/DeliveryMenu';

import packageInfo from '../../../package.json';

const { Sider } = Layout;

export default class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVersion: false,
    };
  }

  _getMenuOpenKeysListBasedOnPath = (path = '') => {
    const pathArr = path.split('/');
    const result = pathArr.filter((value, index, array) =>
      index !== 0 && index < array.length ? value : null,
    );
    return result;
  };

  // PASS MODULE AS REFERENCES
  _renderOrganizationMenu = Organization;
  _renderBillerMenu = AllBillers;
  _renderGoldMenu = GoldMenu;
  _renderDeliveryMenu = Delivery;

  _renderUserMenu = onLink => (
    <Menu.Item key={route.USER_CONTROL}>
      <Link to={route.USER_CONTROL} onClick={onLink} className="center-content">
        <UserControlIcon />
        <span>{this.props.intl.formatMessage({ id: `userControl` })}</span>
      </Link>
    </Menu.Item>
  );

  _renderAuditMenu = (location, onLink) => {
    const pathname = get(location, 'pathname', '');
    let auditRoute;
    if (pathname.includes(route.AUDIT)) {
      auditRoute = pathname;
    }
    return (
      <Menu.Item key={auditRoute}>
        <Link to={route.AUDIT} onClick={onLink} className="center-content">
          <AuditIcon />
          <span>{this.props.intl.formatMessage({ id: `audit` })}</span>
        </Link>
      </Menu.Item>
    );
  };

  _renderLoading = () => <div className="shine loading-menu" />;

  _showVersion = () => {
    if (process.env.SENTRY_ENV === 'Staging') {
      this.setState({
        showVersion: true,
      });
    }
  };

  _closeModal = () => {
    this.setState({ showVersion: false });
  };

  render() {
    const { location, token, confirmNavigate } = this.props;
    const { checkPermission } = permissionService;
    const section = this._getMenuOpenKeysListBasedOnPath(location.pathname);
    const canAccessDelivery =
      checkPermission('Order List') ||
      checkPermission('Partner Management') ||
      checkPermission('Client');

    return (
      <Sider width={240} className="custom-sider scroll-show">
        <Menu
          theme="light"
          defaultSelectedKeys={[location.pathname]}
          selectedKeys={[location.pathname]}
          defaultOpenKeys={section}
          mode="inline"
        >
          {(checkPermission('Form Builder') ||
            checkPermission('Service') ||
            checkPermission('Biller') ||
            checkPermission('Transaction Log')) &&
            (get(token, 'all-billers')
              ? this._renderBillerMenu(location)
              : this._renderLoading())}

          {checkPermission('Transaction Log') &&
            (get(token, 'emas')
              ? this._renderGoldMenu(location, confirmNavigate)
              : this._renderLoading())}

          {(checkPermission('Company') ||
            checkPermission('Employee') ||
            checkPermission('Role')) &&
            (get(token, 'organization')
              ? this._renderOrganizationMenu(location, confirmNavigate)
              : this._renderLoading())}

          {checkPermission('Audit:read', true) &&
            this._renderAuditMenu(location, confirmNavigate)}
          {canAccessDelivery &&
            (get(token, 'delivery')
              ? this._renderDeliveryMenu({ location, onLink: confirmNavigate })
              : this._renderLoading())}

          {this._renderUserMenu(confirmNavigate)}
        </Menu>
        <div className="version" onClick={this._showVersion}>
          {`Business Central v${packageInfo.version}`}
        </div>
        <Modal
          footer={false}
          title={
            <OneRowData
              data={{
                label: 'Business Central',
                value: `v${packageInfo.version}`,
              }}
            />
          }
          closable={false}
          centered
          visible={this.state.showVersion}
          width={320}
          onCancel={this._closeModal}
        >
          <OneRowData
            data={{
              label: 'All Biller',
              value: `v${packageInfo.modules.allbiller}`,
            }}
          />
          <OneRowData
            data={{
              label: 'Audit',
              value: `v${packageInfo.modules.audit}`,
            }}
          />
          <OneRowData
            data={{
              label: 'Delivery',
              value: `v${packageInfo.modules.delivery}`,
            }}
          />
          <OneRowData
            data={{
              label: 'eMAS',
              value: `v${packageInfo.modules.gold}`,
            }}
          />
          <OneRowData
            data={{
              label: 'Organization',
              value: `v${packageInfo.modules.organization}`,
            }}
          />
        </Modal>
      </Sider>
    );
  }
}

SideBar.propTypes = {
  location: PropTypes.object,
  intl: PropTypes.object.isRequired,
  confirmNavigate: PropTypes.func,
  token: PropTypes.object,
};
